import { create } from "zustand";
import videoPlaceholderImg from "../assets/images/sidom/fotos/bg-default (2).jpg";
import {
  getHomeBloqus,
  getHomes,
  getHomeBloque1s,
  getHomeBloque2s,
  // Contenido Principal
  getNovedades,
  getEventos,
  getHomeVideos, // Videos de la página principal (Home)
  getSmartReaders, // Datos de Smart Readers
  getTestimonioById,
  getTestimonioMarcas,
  getTestimonioUSer,
  getClientes,
  getHomeHero,
  getHeroInsurances,
  getHeroComex,
  getBeneficiosComex,
  getAutomotrizComex,
  getContactoComex,
  getMarcasComex,
  getTestimonioComex,
  getVideoComex,
  getCertificaciones,
  getContactosHeroes,
  getMreHeroes,
  getNosotrosHeroes,
  getNosotrosTeams,
  getPayHeroes,
  getSmartReaderHeroes,
  getMisimHeroes,
  getMisimTestimonios,
  getMisimClientes,
  getEventoHeroes,
  getBlogHeroes,
  getKitPartnes,
  getComercios,
  getVentas,
  getSeoEventos,
  getSeoHomes,
  getSeoInsurances,
  getSeoMisims,
  getSeoMres,
  getSeoNosotros,
  getSeoNovedades,
  getSeoPays,
  getSeoSmartReaders,
  getMreCardsService,
  getMreVideos, // <--- Importar función para videos MRE
  getMisimVideos, // <--- Importar función para videos institucionales
  getPWCCategories,
  searchPWCPreguntas,
  getPWCPreguntaById,
  getHomeCarousel,
  getContactoAgenda,
  // createBitacora,
  // updateBitacora,
  // deleteBitacora,
} from "../services/api";

// Creación del store global usando Zustand
const useStore = create((set) => ({
  // Videos institucionales
  misimVideos: [],
  fetchMisimVideos: async () => {
    set({ loading: true });
    try {
      const data = await getMisimVideos();
      set({ misimVideos: data });
    } finally {
      set({ loading: false });
    }
  },
  homeBloqus: [],
  homes: [],
  homeBloque1s: [],
  homeBloque2s: [],
  slides: [],

  fetchHomeBloqus: async () => {
    set({ loading: true });
    try {
      const data = await getHomeBloqus();
      set({ homeBloqus: data });
    } finally {
      set({ loading: false });
    }
  },
  fetchHomes: async () => {
    set({ loading: true });
    try {
      const data = await getHomes();
      set({ homes: data });
    } finally {
      set({ loading: false });
    }
  },
  fetchHomeBloque1s: async () => {
    set({ loading: true });
    try {
      const data = await getHomeBloque1s();
      set({ homeBloque1s: data });
    } finally {
      set({ loading: false });
    }
  },
  fetchHomeBloque2s: async () => {
    set({ loading: true });
    try {
      const data = await getHomeBloque2s();
      set({ homeBloque2s: data });
    } finally {
      set({ loading: false });
    }
  },
  fetchHomeCarousel: async () => {
    set({ loading: true });
    try {
      const items = await getHomeCarousel();
      set({ slides: items });
      return { slides: items};

    } finally {
      set({ loading: false });
    }
  },
  // Estado inicial para el contenido principal
  novedades: [], // Artículos y novedades
  eventos: [], // Eventos y actividades

  // Estado para testimonios y referencias
  testimonioclientes: [], // Testimonios de clientes
  testimonioMarcas: [], // Testimonios de marcas asociadas
  testimonioUser: [], // Testimonios de usuarios
  clientes: [], // Lista de clientes

  // Estado para secciones Comex
  heroComex: [], // Hero section de Comex
  beneficiosComex: [], // Beneficios de Comex
  home: [], // Contenido de la página principal
  insurances: [], // Información de seguros
  automotrizComex: [], // Sección automotriz
  contactoComex: [], // Información de contacto
  marcasComex: [], // Marcas asociadas a Comex
  testimonioComex: [], // Testimonios específicos de Comex
  videoComex: [], // Videos de Comex
  certificacion: [], // Certificaciones

  // Estado para control de carga
  loading: false, // Indicador de carga global

  setVideoUrlError: (error) => set({ videoUrlError: error }),
  videoUrlError: null,
  videoPlaceholder: videoPlaceholderImg,

  setVideoPlaceholder: (url) => set({ videoPlaceholder: url }),

  // Estado para videos y datos de Smart Readers
  homeVideos: [], // Videos de la página principal (Home)
  smartReaders: [], // Datos de Smart Readers

  // Función para obtener las novedades desde la API

  fetchNovedades: async () => {
    set({ loading: true });
    try {
      const data = await getNovedades();
      set((state) => {
        const nuevos = data?.data || [];
        if (JSON.stringify(state.novedades) === JSON.stringify(nuevos)) {
          return { loading: false };
        }
        return { novedades: nuevos, loading: false };
      });
    } catch (error) {
      console.error("Error fetching novedades:", error);
      set({ loading: false });
    }
  },

  fetchEventos: async () => {
    set({ loading: true });
    try {
      const data = await getEventos();
      set((state) => {
        const nuevos = data?.data || [];
        if (JSON.stringify(state.eventos) === JSON.stringify(nuevos)) {
          return { loading: false };
        }
        return { eventos: nuevos, loading: false };
      });
    } catch (error) {
      console.error("Error fetching eventos:", error);
      set({ loading: false });
    }
  },

  fetchTestimonioById: async () => {
    try {
      set({ loading: true });
      const data = await getTestimonioById();

      if (Array.isArray(data)) {
        set({ testimonioclientes: data, loading: false });
      } else {
        console.warn(
          "La respuesta de la API no contiene un array esperado:",
          data
        );
        set({ testimonio: [], loading: false });
      }

      return data;
    } catch (error) {
      console.error("Error fetching testimonio by id:", error);
      set({ loading: false });
      return null;
    }
  },
  getTestimonioMarcas: async () => {
    try {
      set({ loading: true });
      const data = await getTestimonioMarcas();

      set({ testimonioMarcas: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching marcas:", error);
      set({ loading: false });
    }
  },
  getTestimonioUSer: async () => {
    try {
      set({ loading: true });
      const data = await getTestimonioUSer();

      if (Array.isArray(data)) {
        set({ testimonioUser: data, loading: false });
      } else {
        console.warn(
          "La respuesta de la API no contiene un array esperado:",
          data
        );
        set({ testimonioUser: [], loading: false });
      }

      return data;
    } catch (error) {
      console.error("Error fetching testimonio by id:", error);
      set({ loading: false });
      return null;
    }
  },
  fetchClientes: async () => {
    try {
      set({ loading: true });
      const data = await getClientes();

      if (Array.isArray(data)) {
        set({ clientes: data, loading: false });
      } else {
        console.warn(
          "La respuesta de la API no contiene un array esperado:",
          data
        );
        set({ clientes: [], loading: false });
      }

      return data;
    } catch (error) {
      console.error("Error fetching clientes:", error);
      set({ loading: false });
      return null;
    }
  },
  getHomeHero: async () => {
    try {
      set({ loading: true });
      const data = await getHomeHero();

      set({ home: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching marcas:", error);
      set({ loading: false });
    }
  },
  getHeroInsurances: async () => {
    try {
      set({ loading: true });
      const data = await getHeroInsurances();
      set({ insurances: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching hero insurances:", error);
      set({ loading: false });
    }
  },
  getHeroComexBox: async () => {
    try {
      set({ loading: true });
      const data = await getHeroComex();

      set({ heroComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching hero insurances:", error);
      set({ loading: false });
    }
  },
  getBeneficiosComex: async () => {
    try {
      set({ loading: true });
      const data = await getBeneficiosComex();
      set({ beneficiosComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching beneficios-comexes:", error);
      set({ loading: false });
    }
  },
  getAutomotrizComex: async () => {
    try {
      set({ loading: true });
      const data = await getAutomotrizComex();
      set({ automotrizComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching automotriz-comexes:", error);
      set({ loading: false });
    }
  },
  getContactoComex: async () => {
    try {
      set({ loading: true });
      const data = await getContactoComex();
      set({ contactoComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching contacto-comexes:", error);
      set({ loading: false });
    }
  },
  getMarcasComex: async () => {
    try {
      set({ loading: true });
      const data = await getMarcasComex();
      set({ marcasComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching marcas-comexes:", error);
      set({ loading: false });
    }
  },
  getTestimonioComex: async () => {
    try {
      set({ loading: true });
      const data = await getTestimonioComex();
      set({ testimonioComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching testimonio-comexes:", error);
      set({ loading: false });
    }
  },
  getVideoComex: async () => {
    try {
      set({ loading: true });
      const data = await getVideoComex();
      set({ videoComex: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching video-comexes:", error);
      set({ loading: false });
    }
  },
  getCertificacionesAll: async () => {
    try {
      set({ loading: true });
      const data = await getCertificaciones();
      set({ certificacion: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching video-comexes:", error);
      set({ loading: false });
    }
  },
  contactosHeroes: [],
  mreHeroes: [],
  nosotrosHeroes: [],
  nosotrosTeams: [],
  payHeroes: [],
  smartReaderHeroes: [],
  misimHeroes: [],
  misimTestimonios: [],
  misimClientes: [],
  eventoHeroes: [],
  blogHeroes: [],
  kitPartnes: [],
  comercios: [],
  ventas: [],
  mreCards: [],
  mreVideos: [], // Videos de MRE
  // PwC Q&A
  pwcPreguntas: [],
  pwcSearch: { data: [], meta: { pagination: { page: 1, pageSize: 8, pageCount: 1, total: 0 } } },
  contactoAgenda: [],

  getContactosHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getContactosHeroes();

      set({ contactosHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching contactos-heroes:", error);
      set({ loading: false });
    }
  },
  getMreHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getMreHeroes();
      set({ mreHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching mre-heroes:", error);
      set({ loading: false });
    }
  },
  getNosotrosHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getNosotrosHeroes();

      set({ nosotrosHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching nosotros-heroes:", error);
      set({ loading: false });
    }
  },
  getNosotrosTeams: async () => {
    try {
      set({ loading: true });
      const data = await getNosotrosTeams();
      set({ nosotrosTeams: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching nosotros-teams:", error);
      set({ loading: false });
    }
  },
  getPayHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getPayHeroes();
      set({ payHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching pay-heroes:", error);
      set({ loading: false });
    }
  },
  getSmartReaderHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getSmartReaderHeroes();
      set({ smartReaderHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching smart-reader-heroes:", error);
      set({ loading: false });
    }
  },
  getMisimHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getMisimHeroes();
      set({ misimHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching misim-heroes:", error);
      set({ loading: false });
    }
  },
  fetchMisimTestimonios: async () => {
    try {
      set({ loading: true });
      const data = await getMisimTestimonios();
      set({ misimTestimonios: data?.data || [], loading: false });
    } catch (error) {
      console.error("Error fetching misim-testimonios:", error);
      set({ loading: false });
    }
  },
  fetchMisimClientes: async () => {
    try {
      set({ loading: true });
      const data = await getMisimClientes();
      set({ misimClientes: data?.data || [], loading: false });
    } catch (error) {
      console.error("Error fetching misim-clientes:", error);
      set({ loading: false });
    }
  },
  getEventoHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getEventoHeroes();
      set({ eventoHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching evento-heroes:", error);
      set({ loading: false });
    }
  },
  getBlogHeroes: async () => {
    try {
      set({ loading: true });
      const data = await getBlogHeroes();
      set({ blogHeroes: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching blog-heroes:", error);
      set({ loading: false });
    }
  },
  fetchKitPartnes: async () => {
    try {
      set({ loading: true });
      const data = await getKitPartnes();
      set({ kitPartnes: data, loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchComercios: async () => {
    try {
      set({ loading: true });
      const data = await getComercios();
      set({ comercios: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchVentas: async () => {
    try {
      set({ loading: true });
      const data = await getVentas();
      set({ ventas: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  // --- DATOS SEO ---
  // Estado para almacenar la información SEO de cada sección
  seoEventos: [], // Meta datos para página de eventos
  seoHomes: [], // Meta datos para página principal
  seoInsurances: [], // Meta datos para sección de seguros
  seoMisims: [], // Meta datos para sección MISIM
  seoMres: [], // Meta datos para sección MRE
  seoNosotros: [], // Meta datos para página Nosotros
  seoNovedades: [], // Meta datos para sección de novedades
  seoPays: [], // Meta datos para sección de pagos
  seoSmartReaders: [], // Meta datos para Smart Readers

  // Función para obtener los meta datos SEO de eventos
  fetchSeoEventos: async () => {
    try {
      set({ loading: true }); // Activar indicador de carga
      const data = await getSeoEventos(); // Obtener datos SEO de la API
      set({ seoEventos: data || [], loading: false }); // Actualizar estado con datos o array vacío
    } catch (error) {
      set({ loading: false }); // Desactivar indicador de carga en caso de error
      // Aquí no se muestra el error en consola ya que es metadata opcional
    }
  },
  fetchSeoHomes: async () => {
    try {
      set({ loading: true });
      const data = await getSeoHomes();
      set({ seoHomes: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchSeoInsurances: async () => {
    try {
      set({ loading: true });
      const data = await getSeoInsurances();
      set({ seoInsurances: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchSeoMisims: async () => {
    try {
      set({ loading: true });
      const data = await getSeoMisims();
      set({ seoMisims: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchSeoMres: async () => {
    try {
      set({ loading: true });
      const data = await getSeoMres();
      set({ seoMres: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchSeoNosotros: async () => {
    try {
      set({ loading: true });
      const data = await getSeoNosotros();
      set({ seoNosotros: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchSeoNovedades: async () => {
    try {
      set({ loading: true });
      const data = await getSeoNovedades();
      set({ seoNovedades: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchSeoPays: async () => {
    try {
      set({ loading: true });
      const data = await getSeoPays();
      set({ seoPays: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  fetchSeoSmartReaders: async () => {
    try {
      set({ loading: true });
      const data = await getSeoSmartReaders();
      set({ seoSmartReaders: data || [], loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
  getMreCards: async () => {
    try {
      const response = await getMreCardsService();
      set({ mreCards: response.data });
    } catch (error) {
      console.error("Error fetching MRE cards:", error);
      set({ mreCards: [] });
    }
  },
  /**
   * Obtiene los videos de MRE y actualiza el estado
   */
  getMreVideos: async () => {
    try {
      set({ loading: true });
      const data = await getMreVideos();
      set((state) => {
        const nuevos = data || [];
        if (JSON.stringify(state.mreVideos) === JSON.stringify(nuevos)) {
          return { loading: false };
        }
        return { mreVideos: nuevos, loading: false };
      });
    } catch (error) {
      console.error("Error fetching mre-videos:", error);
      set({ loading: false });
    }
  },
  /**
   * Obtiene los videos de la página principal (Home) y actualiza el estado
   */
  fetchHomeVideos: async () => {
    try {
      set({ loading: true });
      const data = await getHomeVideos();
      set((state) => {
        const nuevos = data || [];
        if (JSON.stringify(state.homeVideos) === JSON.stringify(nuevos)) {
          return { loading: false };
        }
        return { homeVideos: nuevos, loading: false };
      });
    } catch (error) {
      console.error("Error fetching home-videos:", error);
      set({ loading: false });
    }
  },
  /**
   * Obtiene los datos de Smart Readers y actualiza el estado
   */
  fetchSmartReaders: async () => {
    try {
      set({ loading: true });
      const data = await getSmartReaders();
      set((state) => {
        const nuevos = data || [];
        if (JSON.stringify(state.smartReaders) === JSON.stringify(nuevos)) {
          return { loading: false };
        }
        return { smartReaders: nuevos, loading: false };
      });
    } catch (error) {
      console.error("Error fetching smart-readers:", error);
      set({ loading: false });
    }
  },

  fetchPWCCategories: async () => {
    try {
      set({ loading: true });
      const data = await getPWCCategories();
      set({ categorias: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching PWC categories:", error);
      set({ loading: false });
    }
  },

  searchPWCPreguntas: async ({ q, categoriaId, page = 1, pageSize = 8 } = {}) => {
    try {
      set({ loading: true });
      const res = await searchPWCPreguntas({ q, categoriaId, page, pageSize });
      set({ pwcSearch: res || { data: [], meta: { pagination: { page, pageSize, pageCount: 1, total: 0 } } }, loading: false });
    } catch (error) {
      console.error("Error searching PWC preguntas:", error);
      set({ loading: false });
    }
  },
  
  getPWCPreguntaById: async (id) => {
    try {
      set({ loading: true });
      const res = await getPWCPreguntaById(id);
      set({ loading: false });
      return res;
    } catch (error) {
      console.error("Error get by id PWC pregunta:", error);
      set({ loading: false });
      return null;
    }
  },

  getContactoAgenda: async () => {
    try {
      set({ loading: true });
      const data = await getContactoAgenda();
      set({ contactoAgenda: data || [], loading: false });
    } catch (error) {
      console.error("Error fetching contacto-agendas:", error);
      set({ loading: false });
    }
  },
  // Estado para bitácoras
  // bitacoras: [],
  // // Acción para crear una bitácora
  // createBitacora: async (data) => {
  //   try {
  //     const res = await createBitacora(data);
  //     console.log("Bitácora creada:", res.data);
  //     set((state) => ({ bitacoras: [res.data, ...state.bitacoras] }));
  //     return res.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  // // Acción para actualizar una bitácora
  // updateBitacora: async (id, data) => {
  //   try {
  //     const res = await updateBitacora(id, data);
  //     console.log("Bitácora creada:", res.data);
  //     set((state) => ({
  //       bitacoras: state.bitacoras.map((b) => (b.id === id ? res.data : b)),
  //     }));
  //     return res.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  // // Acción para eliminar una bitácora
  // deleteBitacora: async (id) => {
  //   try {
  //     await deleteBitacora(id);

  //     set((state) => ({
  //       bitacoras: state.bitacoras.filter((b) => b.id !== id),
  //     }));
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  // // Acción para obtener todas las bitácoras del backend
  // fetchBitacoras: async () => {
  //   try {
  //     set({ loading: true });
  //     const res = await fetch(
  //       `${process.env.REACT_APP_STRAPI_URL}/api/bitacoras?pagination[pageSize]=1000`
  //     ).then((r) => r.json());
  //     set({ bitacoras: res.data || [], loading: false });
  //   } catch (error) {
  //     set({ loading: false });
  //     console.error("Error al obtener bitácoras:", error);
  //   }
  // },
}));

export default useStore;
